// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"debug_checkbox__nbbmg","checkbox_label":"debug_checkbox_label__1AWmn"};